import React, { useState, Fragment } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
export default function CategoryTag({
    visible,
    toggle,
    handleAddCategoryTag,
    isEdit,
    categoryList
}) {
    const [oldTitle, setoldTitle] = useState("0");
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [newTitle, setNewTitle] = useState("");
    const handleChangeTitle = (e) => {
        setNewTitle(e.target.value);
    }
    const handleCategoryChange = (e) => {
        setoldTitle(e.target.value);
        setNewTitle(e.target.value);
    }
    const handleSave = () => {
        handleAddCategoryTag(newTitle, oldTitle);
        toggle();
    }
    return (
        <Modal isOpen={visible} toggle={() => toggle()}>
            <ModalHeader toggle={() => toggle()}>Category Tag</ModalHeader>
            <ModalBody>
                <Row>
                    {isEdit === true && (
                        <Fragment>
                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                <Label>Select Category</Label>
                                <Input
                                    type="select"
                                    name="oldtitle"
                                    value={oldTitle}
                                    onChange={(e) => handleCategoryChange(e)}
                                ><option value="0">Select</option>
                                    {categoryList.filter(k => k.value !== "new").map((item, i) =>
                                        <option value={item.value} key={i}>{item.label}</option>
                                    )}</Input>
                            </Colxx>
                        </Fragment>
                    )}
                    <Colxx sm={12} style={{ marginBottom: "10px" }}>
                        <Label>Title</Label>
                        <Input
                            type="text"
                            name="title"
                            value={newTitle}
                            onChange={(e) => handleChangeTitle(e)}
                        />
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter>
                {isEdit === true ?
                    <Button
                        color="primary"
                        onClick={() => handleSave()}
                    >
                        <IntlMessages id='dashboards.update' />
                    </Button> :
                    <Button
                        color="primary"
                        onClick={() => handleSave()}
                    >
                        Add
                    </Button>}

                <Button
                    color="secondary"
                    onClick={() => toggle()}
                >
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    )
}